/* eslint-disable no-unused-vars */
import Swiper, {Navigation, Lazy} from 'swiper';
Swiper.use([Navigation, Lazy]);

let homeSlider = null;

function changeInfo(data) {
	const $sliderName = document.querySelector('.slider__name');
	const $sliderCity = document.querySelector('.slider__city');
	const index = data.activeIndex;
	const currentSlide = data.slides[index];
	const name = currentSlide.dataset.name;
	const city = currentSlide.dataset.city;

	$sliderName.textContent = name;
	$sliderCity.textContent = city;
}

function init(container) {
	const $el = document.querySelector('.homeSlider');

	if ($el === null) {
		return;
	}

	homeSlider = new Swiper($el, {
		slidesPerView: 1,
		lazy: {
			loadPrevNext: true,
			loadPrevNextAmount: 2,
		},
		loop: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	});

	homeSlider.on('slideChange', (e) => changeInfo(e));
}

function destroy() {
	homeSlider.destroy();
}

export default {
	init,
	destroy,
};
